import { api } from "../httpClient";

/**
 * Submit car rental survey
 * @param {Object} surveyData - Survey responses and comments
 * @returns {Promise<Object>} API response
 */
export const submitSurvey = async (surveyData) => {
  // Transform the data to match the required API format
  const transformedData = {
    reservation_number: surveyData.reservation_number,
    pricingGood: surveyData.pricing === 1 ? 1 : 0,
    pricingBad: surveyData.pricing === 0 ? 1 : 0,
    waitTimeGood: surveyData.waitTime === 1 ? 1 : 0,
    waitTimeBad: surveyData.waitTime === 0 ? 1 : 0,
    staffServiceGood: surveyData.staffService === 1 ? 1 : 0,
    staffServiceBad: surveyData.staffService === 0 ? 1 : 0,
    vehicleConditionGood: surveyData.vehicleCondition === 1 ? 1 : 0,
    vehicleConditionBad: surveyData.vehicleCondition === 0 ? 1 : 0,
    pickupLocationGood: surveyData.pickupLocation === 1 ? 1 : 0,
    pickupLocationBad: surveyData.pickupLocation === 0 ? 1 : 0,
    overallExperienceGood: surveyData.overallExperience === 1 ? 1 : 0,
    overallExperienceBad: surveyData.overallExperience === 0 ? 1 : 0,
    comments: surveyData.comments || ""
  };

  const response = await api.post("https://python.caledontech.co/api/save_survey", transformedData);
  return response;
};
